import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { alertActions } from "../../actions";
import { contentRef } from "../../firebase";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'rgba(0, 0, 0, .03)',
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
      marginBottom: -1,
      minHeight: 56,
      '&$expanded': {
        minHeight: 56,
      },
    },

    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    assetContainer: {
      border: "1px solid #a1a1a1",
      boxShadow: "2px 2px 2px 2px #a1a1a1",
      margin: "20px 0",
      padding: 30
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      fontFamily:"Bogart Regular !important",
    },
    contentContainer: {
      marginTop: 40,
      display:"block"
    },
    editableContent: {
      width: 500
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    submit: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5)
    },
    assetButtons: {

    }
  }),
);

interface IAsset {
  name: string,
  url: string
}

interface InitContent {
  [key: string]: any,
  title: string,
  heading: string,
  body: string,
  links: Array<IAsset>,
  images: Array<IAsset>,
  videos: Array<IAsset>
}

export const AdminPage = () => {
  const initContent: InitContent = {
    title: "",
    heading: "",
    body: "",
    links: [{
      name: "",
      url: ""
    }],
    images: [{
      name: "",
      url: ""
    }],
    videos: [{
      name: "",
      url: ""
    }],
  };
  const [content, setContent] = useState([initContent]);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    contentRef.get()
      .then((snapshot) => {
        if (!snapshot.exists()) {
          setContent([initContent]);
          return;
        }

        const data = snapshot.val();
        setContent(data.content);
      }, error => {
        setTimeout(() => {
        }, 5000);
      });
  },[dispatch]);

  const handleContentChange = (event: React.SyntheticEvent, index: number) => {
    const { name, value } = (event.currentTarget as HTMLInputElement);
    const newContent = [...content];
    newContent[index][name] = value;
    setContent(newContent);
  };

  const handleContentAssetChange = (event: React.SyntheticEvent, index: number, assetType: string, assetIndex: number) => {
    const { name, value } = (event.currentTarget as HTMLInputElement);
    const newContent = [...content];
    newContent[index][assetType][assetIndex][name] = value;
    setContent(newContent);
  };

  const handleAddAsset = (index: number) => () => {
    let linkList = [...content[index].links];
    linkList.push({name: "", url: ""});
    const newContent = [...content];
    newContent[index].links = linkList;
    setContent(newContent);
  };

  const handleRemoveAsset = (index: number, linkIndex: number) => () => {
    const linkList = [...content[index].links];
    linkList.splice(linkIndex, 1);
    const newContent = [...content];
    newContent[index].links = linkList;
    setContent(newContent);
  };

  const handleAddStep = () => {
    const contentList = [...content];
    contentList.push(initContent);
    setContent(contentList);
  };

  const handleRemoveStep = (index: number) => () => {
    const contentList = [...content];
    contentList.splice(index, 1);
    setContent(contentList);
  };

  const handleUpdatePageContent = (event: React.SyntheticEvent) => {
    event.preventDefault();

    contentRef.set({
      content
    }, (error) => {
      // TODO handle error
      if (error) {
        console.log(error)
      } else {
      }
      setTimeout(() => {
      }, 5000);
    });
  }

  return (
    <Container className={classes.container}>
      <h1>Vettie Step Content</h1>
      <Grid container direction="column" justify="center" alignItems="center">
      {content.map((section, index) => (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Section {index + 1}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid className={classes.contentContainer} container direction="column" justify="center" alignItems="center">
                <Grid item xs={12}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      key={"title-" + index}
                      className={classes.editableContent}
                      id={"title-content-" + index}
                      name="title"
                      label="Title"
                      multiline
                      value={section.title}
                      onChange={event => handleContentChange(event, index)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      key={"heading-" + index}
                      className={classes.editableContent}
                      id={"heading-content-" + index}
                      name="heading"
                      label="Heading"
                      multiline
                      value={section.heading}
                      onChange={event => handleContentChange(event, index)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      key={"body-" + index}
                      className={classes.editableContent}
                      id={"body-content-" + index}
                      name="body"
                      label="Body"
                      multiline
                      value={section.body}
                      onChange={event => handleContentChange(event, index)}
                    />
                  </FormControl>
                </Grid>
                <Grid className={classes.assetContainer} container direction="column" justify="flex-end" alignItems="center">
                  <Typography variant="h6">Links</Typography>
                  {section.links.map((link, linkIndex) => (
                  <React.Fragment>
                  <Grid container direction="row" justify="flex-start">
                    <Grid item xs={6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          key={"link-name-" + linkIndex}
                          className={classes.editableContent}
                          id={"link-name-content-" + index + "-" + linkIndex}
                          name="name"
                          label="Link Name"
                          multiline
                          value={link.name}
                          onChange={event => handleContentAssetChange(event, index, "links", linkIndex)}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          key={"link-url-" + linkIndex}
                          className={classes.editableContent}
                          id={"link-url-content-" + index + "-" + linkIndex}
                          name="url"
                          label="Link URL"
                          multiline
                          value={link.url}
                          onChange={event => handleContentAssetChange(event, index, "links", linkIndex)}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid container direction="row">
                    <FormControl className={classes.assetButtons}>
                      {section.links.length !== 1 && <Button color="primary" onClick={handleRemoveAsset(index, linkIndex)}>Remove</Button>}
                    </FormControl>
                    <FormControl className={classes.assetButtons}>
                      {section.links.length - 1 === linkIndex && <Button color="primary" onClick={handleAddAsset(index)}>Add</Button>}
                    </FormControl>
                  </Grid>
                  </React.Fragment>
                ))}
                </Grid>
                <Grid className={classes.assetContainer} container direction="column" justify="flex-end" alignItems="center">
                  <Typography variant="h6">Images</Typography>
                  {section.images.map((image, imageIndex) => (
                  <React.Fragment>
                  <Grid container direction="row" justify="flex-start">
                    <Grid item xs={6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          key={"image-name-" + imageIndex}
                          className={classes.editableContent}
                          id={"image-name-content-" + index + "-" + imageIndex}
                          name="name"
                          label="Image Name"
                          multiline
                          value={image.name}
                          onChange={event => handleContentAssetChange(event, index, "images", imageIndex)}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          key={"image-url-" + imageIndex}
                          className={classes.editableContent}
                          id={"image-url-content-" + index + "-" + imageIndex}
                          name="url"
                          label="Image URL"
                          multiline
                          value={image.url}
                          onChange={event => handleContentAssetChange(event, index, "images", imageIndex)}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid container direction="row">
                    <FormControl className={classes.assetButtons}>
                      {section.images.length !== 1 && <Button color="primary" onClick={handleRemoveAsset(index, imageIndex)}>Remove</Button>}
                    </FormControl>
                    <FormControl className={classes.assetButtons}>
                      {section.images.length - 1 === imageIndex && <Button color="primary" onClick={handleAddAsset(index)}>Add</Button>}
                    </FormControl>
                  </Grid>
                  </React.Fragment>
                  ))}
                </Grid>
                <Grid className={classes.assetContainer} container direction="column" justify="flex-end" alignItems="center">
                  <Typography variant="h6">Videos</Typography>
                  {section.videos.map((video, videoIndex) => (
                  <React.Fragment>
                  <Grid container direction="row" justify="flex-start">
                    <Grid item xs={6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          key={"video-name-" + videoIndex}
                          className={classes.editableContent}
                          id={"video-name-content-" + index + "-" + videoIndex}
                          name="name"
                          label="Video Name"
                          multiline
                          value={video.name}
                          onChange={event => handleContentAssetChange(event, index, "videos", videoIndex)}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          key={"video-url-" + videoIndex}
                          className={classes.editableContent}
                          id={"video-url-content-" + index + "-" + videoIndex}
                          name="url"
                          label="Video URL"
                          multiline
                          value={video.url}
                          onChange={event => handleContentAssetChange(event, index, "videos", videoIndex)}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid container direction="row">
                    <FormControl className={classes.assetButtons}>
                      {section.links.length !== 1 && <Button color="primary" onClick={handleRemoveAsset(index, videoIndex)}>Remove</Button>}
                    </FormControl>
                    <FormControl className={classes.assetButtons}>
                      {section.links.length - 1 === videoIndex && <Button color="primary" onClick={handleAddAsset(index)}>Add</Button>}
                    </FormControl>
                  </Grid>
                  </React.Fragment>
                  ))}
                </Grid>
                <Grid container direction="row">
                  <FormControl className={classes.assetButtons}>
                    {content.length !== 1 && <Button color="primary" onClick={handleRemoveStep(index)}>Remove</Button>}
                  </FormControl>
                  <FormControl className={classes.assetButtons}>
                    {content.length - 1 === index && <Button color="primary" onClick={handleAddStep}>Add</Button>}
                  </FormControl>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
          <Button className={classes.submit} color="primary" onClick={handleUpdatePageContent}>Update</Button>
      </Grid>
    </Container>
  );
};
